import { BehaviorSubject } from 'rxjs';
import { AlertModalProps, AlertSubject, ConfirmModalProps } from './Modal.type';

export const alert$ = new BehaviorSubject<AlertSubject>({
    alerts: [],
    confirms: [],
});

export const modalHelpers = {
    showAlert: (props: AlertModalProps) => {
        const alerts = alert$.getValue().alerts;
        const confirms = alert$.getValue().confirms;
        if (props) {
            props.id = new Date().getTime();
        }
        const currentAlert = alerts.find((alert) => modalHelpers.compareAlertData(alert, props));
        if (currentAlert) {
            return;
        }

        alert$.next({
            alerts: [
                ...alerts,
                props,
            ],
            confirms: [
                ...confirms,
            ],
        });
    },
    hideAlert: () => {
        const alerts = alert$.getValue().alerts;
        const confirms = alert$.getValue().confirms;
        alerts.pop();
        alert$.next({
            alerts: [
                ...alerts,
            ],
            confirms: [
                ...confirms,
            ],
        });
    },
    showConfirm: (props: ConfirmModalProps) => {
        const alerts = alert$.getValue().alerts;
        const confirms = alert$.getValue().confirms;
        if (props) {
            props.id = new Date().getTime();
        }
        alert$.next({
            alerts: [
                ...alerts,
            ],
            confirms: [
                ...confirms,
                props,
            ],
        });
    },
    hideConfirm: () => {
        const alerts = alert$.getValue().alerts;
        const confirms = alert$.getValue().confirms;
        confirms.pop();
        alert$.next({
            alerts: [
                ...alerts,
            ],
            confirms: [
                ...confirms,
            ],
        });
    },
    compareAlertData(data1: AlertModalProps, data2: AlertModalProps) {
        if (data1.type !== data2.type) {
            return false;
        }
        if (data1.title !== data2.title) {
            return false;
        }
        if (data1.message !== data2.message) {
            return false;
        }
        if (data1.returnValue !== data2.returnValue) {
            return false;
        }
        if (data1.okText !== data2.okText) {
            return false;
        }
        if (data1.cancelText !== data2.cancelText) {
            return false;
        }
        return true;
    }
};
